import { Color, SendIcon, TextField } from "@bonliva-crm/ui";
import { useLocale } from "@hooks";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { useAddConsultantEventLogSms } from "../hooks/add-consultant-event-log-sms";
import { EventType } from "../utils/hook-props";
import { getSmsTextHint, smsHelperText } from "@components/sms/sms-text-hint";

type Props = {
  consultantId: string;
  open: boolean;
  onClose: () => void;
  onCompleted: (event?: EventType) => void;
  onError: () => void;
  onBeforeCall: () => void;
};

export function SmsEventModal(props: Props) {
  const { locale } = useLocale();
  const classes = useStyles();
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const smsHint = getSmsTextHint(description);

  useEffect(() => {
    setDescription("");
  }, [props.open]);

  const onError = () => {
    props.onError();
    setLoading(false);
  };

  const onCompleted = (event?: EventType) => {
    props.onClose();
    props.onCompleted(event);
    setLoading(false);
  };

  const onBeforeCall = () => {
    props.onBeforeCall();
    setLoading(true);
  };

  const { addConsultantEventLogSms } = useAddConsultantEventLogSms({
    onError,
    onCompleted,
    onBeforeCall
  });

  const sendSmsEvent = () => {
    addConsultantEventLogSms({
      consultantId: props.consultantId,
      desc: description
    });
  };

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle>{locale.SendSMS}</DialogTitle>
      <DialogContent className={classes.root}>
        <TextField
          multiline
          fullWidth
          minRows={5}
          name="description"
          label={locale.TypeHere}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          error={!smsHint.valid}
          helperText={smsHelperText(smsHint)}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={props.onClose}>
          {locale.Cancel}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={sendSmsEvent}
          disabled={!description.length || !smsHint.valid || loading}
          endIcon={
            <SendIcon
              htmlColor={Color.White}
              style={{ width: "0.75rem", height: "0.75rem" }}
            />
          }
        >
          {locale.Send}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const useStyles = makeStyles(() => ({
  root: {
    minWidth: 500
  }
}));
